import styled from 'styled-components';

import { TippyDefault } from 'app/components/Tippy';

import { SENSOR_STATUS_STYLES, SENSOR_STATUS_TEXT } from 'app/modules/inventory/bins/core/constant';
import { SensorConnectionStatus, SensorSkuId } from 'app/modules/inventory/bins/core/enum';

import { ReactComponent as IconClock } from 'app/assets/icons/icon-clock.svg';
import { ReactComponent as IconHangerNote } from 'app/assets/icons/icon-hanger-note.svg';
import { ReactComponent as IconScale } from 'app/assets/icons/icon-scale.svg';
import { ReactComponent as IconVideo } from 'app/assets/icons/video.svg';

const IconWrapper = styled.figure<SensorStatusProps>`
  margin: 0;
  width: 32px;
  height: 32px;
  padding: 6px;
  border-radius: 8px;
  background-color: ${({ status }) => SENSOR_STATUS_STYLES[status]?.background};
  display: flex;
  align-items: center;
  justify-content: center;

  svg {
    width: 100%;
    height: 100%;
    fill: ${({ status }) => SENSOR_STATUS_STYLES[status]?.icon};

    path {
      fill: ${({ status }) => SENSOR_STATUS_STYLES[status]?.icon};
    }

    circle,
    line {
      stroke: ${({ status }) => SENSOR_STATUS_STYLES[status]?.icon};
    }

    circle:last-child {
      fill: ${({ status }) => SENSOR_STATUS_STYLES[status]?.icon};
    }
  }
`;

interface SensorStatusProps {
  skuId?: string;
  iconWrapperStyle?: React.CSSProperties;
  status: SensorConnectionStatus;
}

export const SensorStatus = ({ skuId, status, iconWrapperStyle }: SensorStatusProps) => {
  const renderIcon = () =>
    ({
      [SensorSkuId.Expiry]: <IconClock />,
      [SensorSkuId.Weight]: <IconScale />,
      [SensorSkuId.CV]: <IconVideo />,
      [SensorSkuId.Hanger]: <IconHangerNote />,
    }[skuId || SensorSkuId.CV]);

  return (
    <TippyDefault content={SENSOR_STATUS_TEXT[status]}>
      <IconWrapper status={status} style={iconWrapperStyle}>
        {renderIcon()}
      </IconWrapper>
    </TippyDefault>
  );
};
